import React, { useState, useEffect } from 'react'
import { CommunityLeadsSalariedValidation } from '../../utils/Validation'
import { useLocation, useNavigate } from 'react-router-dom'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../utils/PiePage.component'
// import Routes from '../../../../Layout/Routes'
import { CommunityLeadSaveUserSalaryApi, CommunityLeadGetUserSalaryApi } from './AddLeadActionCreator'
import InputField from '../../utils/InputMUI'
import SelectField from '../../utils/SelectMUI'

import { educationArr, WEBSITE } from '../../utils/commonFunction'
import moment from 'moment'

const AddUi = ({ Locationdata,handleTab , handlePage}) => {
    const [objectData, setObjectData] = useState({
        nameOfOrganisation: '', monthlySalary: "", salaryDay: "",
        joiningDate: '', totalExperience: '', designation: '', educationQualification: ''
    })
    const [message, setMessage] = useState({})
    const [loaderState, setLoaderState] = useState(false)
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        console.log(Locationdata, "statetetetteett");
        if (Locationdata !== null && Locationdata.rowData !== undefined) {
            let changeObjectData = { ...objectData }
            changeObjectData.userId = Locationdata.rowData.userId
            if (Locationdata.rowData.loanId !== undefined) {
                changeObjectData.loanId = Locationdata.rowData.loanId
            }
            setObjectData(changeObjectData)
            getDetail(changeObjectData)
        }
    }, [])

    const getDetail = (data) => {
        CommunityLeadGetUserSalaryApi(Locationdata.rowData.userId,
            callBack => {
                if (Object.keys(callBack.data).length > 0) {
                    let changeObjectData = Object.assign({}, data)
                    Object.keys(callBack.data).forEach(key => {
                        if (callBack.data[key] !== null) {
                            changeObjectData[key] = callBack.data[key]
                        }
                    });
                    setObjectData(changeObjectData)
                }
            }, error => {

            })
    }

    const inputChange = (e, type) => {
        // console.log(type, e.length)
        let changeObjectData = Object.assign({}, objectData)
        // changeObjectData[type] = e

        if (type === 'monthlySalary') {
            // console.log(e.length)
            if (e.length <= 9) {
                changeObjectData.monthlySalary = e
            } else {
                changeObjectData.monthlySalary = e.slice(0, 9)
            }
        }
        if (type === 'joiningDate') {
            // changeObjectData[type] = moment(e).format('YYYY-MM-DDThh:mm:ssZ')
            changeObjectData[type] = e
        } else if (type !== 'joiningDate' && type !== 'monthlySalary') {
            changeObjectData[type] = e
        }


        setObjectData(changeObjectData)
        setMessage({})
    }

    const saveHandler = (e) => {
        if (e === 'save') {
            let validationMsg = CommunityLeadsSalariedValidation(objectData)
            if (validationMsg.status) {
                setMessage(validationMsg)
                setLoaderState(true)
                CommunityLeadSaveUserSalaryApi(objectData,
                    callBack => {
                        if (Locationdata.rowData.loanId !== undefined) {
                            callBack.data.loanId = Locationdata.rowData.loanId
                        }
                        callBack.data.sourceOfIncome = Locationdata.rowData.sourceOfIncome
                        if (!window.location.href.includes('/external')) {
                            const obj = { 
                                rowData: callBack.data,
                                communityId: Locationdata ? Locationdata.communityId : null,
                                 qrId : Locationdata ? Locationdata.qrId : null 
                               }
                               handleTab("addLeadAddress",obj)
                            // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_ADDRESS : Routes.COMMUNITY_ADD_LEAD_ADDRESS, { state: { rowData: callBack.data, communityId: location.state ? location.state.communityId : null , qrId : location.state ? location.state.qrId : null} })
                        } 
                        setLoaderState(false)
                    },
                    error => {
                        setLoaderState(false)
                    })
            } else {
                setMessage(validationMsg)
            }
        } else if (e === 'close') {
            // if (location.state ? location.state.communityId : null) {
            //     let data = location.state.rowData
            //     data.communityId = location.state ? location.state.communityId : null

            //     navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: data, page: 'communityLeads' } })
            // } else if (location.state ? location.state.qrId : null) {
            //     let data = location.state.rowData
            //     data.qrId = location.state ? location.state.qrId : null
            //     navigate(Routes.SUPER_ADMIN_QR_DETAILS, { state: { rowData: data, page: 'leads' } })
            // } else {
            //     if (window.location.href.includes('admin')) {
            //         navigate(Routes.SUPER_ADMIN_ALL_LEADS)
            //     } else {
            //         navigate(Routes.COMMUNITY_ALL_LEADS)
            //     }
            // }

            handlePage("","list")
        } else if (e === 'back') {
            // if (!window.location.href.includes('/external')) {

            //     navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_PERSONAL : Routes.COMMUNITY_ADD_LEAD_PERSONAL, { state: { rowData: objectData, communityId: location.state ? location.state.communityId : null } })
            // } else {
            //     navigate(Routes.EXTERNAL_COMMUNITY_ADD_LEAD_PERSONAL, { state: { rowData: objectData } })
            // }
const obj = { rowData: objectData, communityId: Locationdata ? Locationdata.communityId : null }
            handleTab("personal",obj)
        }
    }

    return (
        <div className='container hoverNone card'>
            {loaderState ?
                <Loader />
                : null}
            <PiePage
                totalPage={6}
                currentPage={2}
                heading={'Add Salaried Info'}
            />
            <div className=' row' style={{marginBottom:'12px'}}>
                <div className='col-sm-6 col-xs-12'style={{marginBottom:'12px'}}>
                    <InputField
                        label="Name Of Organisation"
                        variant="outlined"
                        value={objectData.nameOfOrganisation}
                        name="nameOfOrganisation"
                        id="nameOfOrganisation"
                        type="text"
                        onChange={e => inputChange(e, 'nameOfOrganisation')}
                        size="small"
                    // required={true}
                    />
                    <div id="nameOfOrganisationHelp" className="form-text text-danger">{message.field === 'nameOfOrganisation' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12'style={{marginBottom:'12px'}}>
                    <InputField
                        label="Monthly Salary"
                        variant="outlined"
                        value={objectData.monthlySalary}
                        name="monthlySalary"
                        id="monthlySalary"
                        type="number"
                        onChange={e => inputChange(e, 'monthlySalary')}
                        size="small"
                    // required={true}
                    />
                    <div id="monthlySalaryHelp" className="form-text text-danger">{message.field === 'monthlySalary' ? message.msg : ""}</div>
                </div>
                <div className=' col-sm-6 col-xs-12'style={{marginBottom:'12px'}}>
                    <InputField
                        label="Salary Day"
                        variant="outlined"
                        value={objectData.salaryDay}
                        name="salaryDay"
                        id="salaryDay"
                        type="Number"
                        onChange={e => inputChange(e, 'salaryDay')}
                        size="small"
                    // required={true}
                    />
                    <div id="salaryDayHelp" className="form-text text-danger">{message.field === 'salaryDay' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12'style={{marginBottom:'12px'}}>
                    {/* <DatePicker
                        label="Joining Date"
                        // format={'MM/dd/yyyy'}
                        value={objectData.joiningDate}
                        name="joiningDate"
                        size="small"
                        onChange={e => inputChange(e, 'joiningDate')}
                    // required={true}
                    /> */}
                     <InputField
                         label="Joining Date"
                        variant="outlined"
                        value={objectData.joiningDate || moment(new Date).format("YYYY-MM-DD")}
                        name="joiningDate"
                        size="small"
                        onChange={e => inputChange(e, 'joiningDate')}
                    // required={true}
                    />
                    <div id="joiningDateHelp" className="form-text text-danger">{message.field === 'joiningDate' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="Total Experience (in months)"
                        variant="outlined"
                        value={objectData.totalExperience}
                        name="totalExperience"
                        id="totalExperience"
                        type="number"
                        onChange={e => inputChange(e, 'totalExperience')}
                        size="small"
                    // required={true}
                    />
                    <div id="totalExperienceHelp" className="form-text text-danger">{message.field === 'totalExperience' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="Designation"
                        variant="outlined"
                        value={objectData.designation}
                        name="designation"
                        id="designation"
                        type="text"
                        onChange={e => inputChange(e, 'designation')}
                        size="small"
                    // required={true}
                    />
                    <div id="designationHelp" className="form-text text-danger">{message.field === 'designation' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <SelectField
                        label={'Education'}
                        onChange={e => inputChange(e, 'educationQualification')}
                        id="education"
                        value={objectData.educationQualification}
                        name="education"
                        data={educationArr}
                        size={'small'}
                    // required={true}
                    />
                    <div id="educationHelp" className="form-text text-danger">{message.field === 'education' ? message.msg : ""}</div>
                </div>
            </div>
            <div className='row' style={{marginBottom:'12px'}}>
                <div className="col-12 text-center">
                    {
                        !window.location.href.includes('/external') ?
                            <button className="cred-btn cancel-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('close')}>Close</button>
                            :
                            <a href={WEBSITE}> <button type="button" className="cred-btn">Close</button></a>
                    }
                    <button className="cred-btn cancel-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('back')}>Back</button>
                    <button className="cred-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('save')}>Save and Continue</button>
                </div>
            </div>
        </div>
    )
}

export default AddUi;